import { GATSBYIMGLOADING } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  showApplePencil?: boolean
  lazy?: boolean
  priority?: boolean
  screen?: {
    alt: string
    img: IGatsbyImageDataObject
  }
  children?: React.ReactNode
  ipadCss?: string
}

function IPadImgV5(props: Props) {
  const { screen, showApplePencil = true, lazy = true, priority = false, children, ipadCss } = props

  const { ipad, heroPencil } = useStaticQuery(
    graphql`
        query {
            ipad: imgixImage(url: "procreate501/hero-ipad.png") {
                gatsbyImageData(layout:FULL_WIDTH, placeholder: BLURRED, imgixParams: {
                    w: 1000
                })
            },
            heroPencil: imgixImage(url: "apple-pencil-flat-min.png") {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
        }
    `,
  )
  return (

    <div className='relative [&>img]:w-full'>


      {showApplePencil &&
        <div className='w-[4.5%] absolute bottom-[-30px] rotate-[36deg] right-[22%] z-3'>
          <GatsbyImage alt={'Every Tuesday Apple Pencil for the iPad Pro'} image={heroPencil.gatsbyImageData} loading={lazy ? GATSBYIMGLOADING.LAZY : GATSBYIMGLOADING.EAGeR} />
        </div>}

      {/* Ipad Image V5 */}
      {screen && <div className='absolute overflow-hidden top-[-3%] left-[-2.65%] scale-[.81] rounded-[7px] z-2 w-full device3-art v5 lg:rounded-[14px]'>
        <GatsbyImage alt={screen.alt} image={screen.img.gatsbyImageData} loading={lazy ? GATSBYIMGLOADING.LAZY : GATSBYIMGLOADING.EAGeR} />
      </div>}

      {priority && <img
        width={'1800'}
        height={'1319'}
        sizes='100vw'
        src={ipad.gatsbyImageData.images.fallback.src}
        srcSet={ipad.gatsbyImageData.images.fallback.srcSet}
        className={ipadCss}
        alt={`Every-tuesday iPad Online Courses`} />}
      {!priority && <GatsbyImage
        className={ipadCss}
        alt={`Every-tuesday iPad Online Courses`}
        image={ipad.gatsbyImageData}
        loading={lazy ? GATSBYIMGLOADING.LAZY : GATSBYIMGLOADING.EAGeR} />}

      {children}

    </div>
  )
}

export default IPadImgV5
